const sections: string[] = [
  'HANDPFLEGE/HAND CARE',
  'FUSSPFLEGE/FOOT CARE',
  'NAGEL / NAILS',
  'WIMPERNVERLÄNGERUNG/EYELASH',
  'OTHER',
];

export default sections;
